import { useContext, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

// context
import MapContext from "../../../services/context/map-context";
import { useAppContext } from "../../../services/context/app-context";
import { useUserContext } from "../../../services/context/user-context";

// utils
import { isMapExist } from "../../../utils/map-layer";

// style
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";



export const SearchLocation = ({ updatePropertyData, searchedResult }) => {
  const { viewOnly } = useUserContext();
  const { map, mapLoaded } = useContext(MapContext);
  const { setPropertyLocation } = useAppContext();
  const markerRef = useRef(null);

  useEffect(() => {
    if (map && mapLoaded && !viewOnly) {
      // Create and add the Geocoder control
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: false, 
        /* marker: {
          color: 'orange'
      }, */
      });

      map.addControl(geocoder);

      // Listen for search results
      geocoder.on("result", saveLocation);

      // Cleanup on unmount
      return () => {
        if (map && mapLoaded && map.getContainer() && geocoder) {
          if (typeof geocoder.off === "function") {
            geocoder.off("result", saveLocation);
          }
          if (
            typeof map.removeControl === "function" &&
            map._container.parentNode &&  isMapExist(map)
          ) {
            map.removeControl(geocoder);
          }
        }
      };
    }
  }, [map, mapLoaded]);

  useEffect(() => {
    if (map && mapLoaded && searchedResult) {
      const coords = searchedResult.geometry.coordinates;
      addMarker(coords);
    }

    // Cleanup on unmount
    return () => {
      if (markerRef.current) markerRef.current.remove();
    };
  }, [searchedResult]);

  const saveLocation = (e) => {
    const selectedLocation = e.result;
    updatePropertyData("locationGeodata", selectedLocation);
    setPropertyLocation(selectedLocation.center);
  };

  const addMarker = (coords) => {
    // remove existing marker
    if (markerRef.current) {
      markerRef.current.remove();
    }

    // add marker at the searched location
    markerRef.current = new mapboxgl.Marker({ color: "#343745" })
      .setLngLat(coords)
      .addTo(map);

    map.flyTo({ center: coords, zoom: 15 });
  };

  return null;
};
